module.exports = __webpack_public_path__ + "img/1546488765.a427a261.jpg";